import * as React from 'react';
import { clsx } from 'clsx';

import * as style from './TableCell.css';
import { getCellStyle } from '../../../../utils/table';

export interface ITableCellProps {
  dragging?: boolean;
  fullWidth?: boolean;
  position?: number;
}

export const TableCell: React.FC<React.PropsWithChildren<ITableCellProps>> = props => {
  const { dragging, children, fullWidth, position } = props;
  const colspan = fullWidth ? 1000 : undefined;
  const styles = React.useMemo(() => getCellStyle(position), [position]);

  const cellStyles = React.useMemo(
    () =>
      clsx(style['cell'], {
        [style['cell--fullwidth']]: fullWidth,
        [style['cell--dragging']]: dragging,
      }),
    [fullWidth, dragging],
  );

  return (
    <td style={styles} colSpan={colspan} className={cellStyles}>
      {children}
    </td>
  );
};
